<!--
 * @Author: chencong
 * @Date: 2020-09-8 17:11:24
 * @LastEditTime: 2020-12-23 12:01:29
 * @LastEditors: ShiWeiShan
 * @Description: 调整流程图
 * @FilePath: \fs-js-pcweb-user\src\components\adjustFlowChart\index.vue
-->
<template>
  <div class="dialog">
    <div class="Workflow-box">
      <div class="Workflow-box-up">
        <span>
          计划年份：
          <el-date-picker
            :value="planYear"
            type="year"
            value-format="yyyy"
            disabled
            placeholder="选择年"
            class="Workflow-up-year"
          ></el-date-picker>
        </span>
        <br />
        <span>
          当前状态：
          <template>
            <i v-if="adjustData.process_status === '1' || type == 'append'">开始</i>
            <i v-else-if="adjustData.process_status === '201'">行政部门审核中</i>
            <i v-else-if="adjustData.process_status === '2'">行政部门审核中</i>
            <i v-else-if="adjustData.process_status === '3'">结束</i>
          </template>
        </span>
        <p v-if="adjustData.process_status == '1' || type == 'append'">发起用水计划调整申请。</p>
        <p v-else-if="adjustData.process_status == '201'">已提交用水计划调整申请，请上传打印扫描后的申请文件。</p>
        <p v-else-if="adjustData.process_status == '2'">已提交用水计划调整申请及相关申请文件，等待行政部门审核。</p>
        <p v-else-if="adjustData.process_status == '3'">流程已结束</p>
      </div>
      <div class="Workflow-box-down">
        <img
          src="../../assets/images/regulate/用水计划调整流程-1.png"
          class="Workflow-img"
          v-if="adjustData.process_status == '1' || type == 'append'"
        />
        <img
          src="../../assets/images/regulate/用水计划调整流程-201.png"
          class="Workflow-img"
          v-else-if="adjustData.process_status == '201'"
        />
        <img
          src="../../assets/images/regulate/用水计划调整流程-2.png"
          class="Workflow-img"
          v-else-if="adjustData.process_status == '2'"
        />
        <img
          src="../../assets/images/regulate/用水计划调整流程-3.png"
          class="Workflow-img"
          v-else-if="adjustData.process_status == '3'"
        />
        <img src="../../assets/images/regulate/用水计划调整流程-1.png" class="Workflow-img" v-else />
      </div>
      <div class="Workflow-box-footer">
        <el-button
          v-if="type !== 'append'"
          type="primary"
          plain
          @click="handleDownloadDoc('downloadAdjust')"
        >下载申请表</el-button>
        <template v-if="type !== 'readOnly'">
          <el-button
            v-if="type === 'append'"
            type="success"
            plain
            @click="handlestatubtn('declare')"
          >用水计划调整申请</el-button>
          <el-button
            v-if="adjustData.process_status == '201'"
            type="success"
            plain
            @click="handlestatubtn('upload')"
          >上传申请扫描文件</el-button>
        </template>
      </div>
    </div>
    <common-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :title="dialogOptions.title"
      :width="dialogOptions.width"
      :height="dialogOptions.height"
      append-to-body
      cover
    >
      <!-- 用水计划调整表单 -->
      <plan-adjust-form
        v-if="dialogname == 'declare'"
        :plan_year="Number(planYear)"
        @successThen="handleSuccessThen"
        @cancle="dialogVisible = false"
      ></plan-adjust-form>
      <!-- 上传申请扫描文件 -->
      <upload-apply-file
        v-else-if="dialogname == 'upload'"
        :recordId="adjustData.oid"
        @successThen="handleSuccessThen"
        @cancle="dialogVisible = false"
      ></upload-apply-file>
    </common-dialog>
  </div>
</template>

<script>
import {
  A_ADD_Adjustyearquery, // 计划调整申请查询
  A_EL_DownloadWaterplanAdjustDoc
} from '@/assets/js/axiosPresets'
import FileSaver from "file-saver"
import uploadApplyFile from './uploadApplyFile'
import planAdjustForm from "@/components/applyForm/planAdjustForm" // 用水计划调整申请
export default {
  components: {
    planAdjustForm,
    uploadApplyFile
  },
  props: {
    planYear: {
      type: String
    },
    type: {
      type: String
    },
    adjustData: {
      type: Object
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      } // 弹框样式
    }
  },
  methods: {
    handleSuccessThen () {
      setTimeout(() => {
        this.dialogVisible = false
      }, 0)
      this.$emit('successThen')
    },
    // 功能：按钮事件
    handlestatubtn (e) {
      this.dialogname = e
      switch (e) {
        case 'declare':
          this.adjustType = ''
          this.dialogOptions = {
            title: this.planYear + '年用水计划调整申请',
            width: '1200px',
            height: '100%'
          }
          break
        case 'upload':
          this.adjustType = ''
          this.dialogOptions = {
            title: '用水计划调整申请附件上传',
            width: '360px'
          }
          break
        case 'downloadAdjust':

          break
      }
      this.dialig_width = '1200px'
      this.dialogVisible = true
    },
    // 功能：打印
    async handleDownloadDoc (type) {
      let url
      const res = await this.$F_checkAxiosIn(A_EL_DownloadWaterplanAdjustDoc(this.adjustData.oid))
      if (!res) {
        return
      }
      url = res.data.Content
      try {
        FileSaver.saveAs(`/fsjs/${url}`, url.split('/').reverse()[0])
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted () {
    console.log(this.adjustData)
  }
}
</script>
